{
  "removeButtonLabel": "Odstrani",
  "removeDescription": "Pritisnite Delete, da odstranite oznako."
}
